export const types = {
	login: '[auth] login',
	signup: '[auth] signup',
	logout: '[auth] logout',
	hasToken: '[auth] hastoken',
	clubCount: '[clubs] clubCount',
	clientsCreate: '[clients] clientsCreate',
};
